import reframe from 'nike-re-framejs';
import Immutable from 'immutable';
import { getUrl } from '@/common/oldMobile';
import { defaultMiddlewares } from '@/common/util';
import axios from 'axios';
import parseEditorTips from '@/nikeone/parseEditorTips';

reframe.registerHandler('homepage/stories/initialize', defaultMiddlewares, db => {
    if (!db.getIn(['homepage', 'stories', 'data'])) {
        axios
            .get(getUrl('STORIES'))
            .then(json => json.stories)
            .then(stories => stories.map(storiesPreparseBetIds))
            .then(deferStoriesBets)
            .catch(() => [])
            .then(stories => reframe.dispatch(['homepage/stories/fetched', stories]));
        return db.setIn(['homepage', 'stories', 'pending'], true);
    }
    return db;
});

export function initStories(db) {
    const stories = (window.INITIAL_DATA.stories || []).map(storiesPreparseBetIds);
    deferStoriesBets(stories);
    return storiesFetchedHandler(db, [stories]);
}

function storiesFetchedHandler(db, [stories]) {
    return db
        .removeIn(['homepage', 'stories', 'pending'])
        .setIn(['homepage', 'stories', 'data'], Immutable.fromJS(stories));
}

reframe.registerHandler('homepage/stories/fetched', defaultMiddlewares, storiesFetchedHandler);

function deferStoriesBets(stories) {
    Promise.resolve(stories)
        .then(collectBetIds)
        .then(betIds => reframe.dispatch(['betbanners/fetch', betIds]));
    return stories;
}

function collectBetIds(stories = []) {
    return stories.reduce((betIds, story) => {
        if (story.betId) {
            betIds.push(story.betId);
        }
        return betIds;
    }, []);
}

const firstKey = v => Object.keys(v)[0];

function storiesPreparseBetIds(story) {
    if (story.betId) {
        const parsed = parseEditorTips(story.betId);
        const betId = firstKey(parsed);
        if (betId) {
            story.betId = betId;
            story.betEditorTip = parsed[betId][0];
        }
    }
    return story;
}
